/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IntegrationActions from '@Actions/integrations/integrationsActions';
import IntegrationCard from './IntegrationCard';
import './style.scss';

/**
 *
 */
const Integration = ({
  user, getIntegrationsLoading, history, getIntegrations, integrations,
}) => {
  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getIntegrations(user?.tenant_info?.org_id);
    }
  }, [user]);

  return (
    <div className="integration-wrapper">
      {!getIntegrationsLoading
        ? (
          <div className="integration-wrapper-margin">
            <IntegrationCard
              type="tally"
              onClick={() => {
                history.push('/admin/integration/tally');
              }}
              enabled={user?.tenant_info?.integration_config?.sub_modules?.tally?.is_active}
              connected={!!(Number(integrations?.result?.integration_tally) > 0)}
            />
            <IntegrationCard
              type="busy"
              onClick={() => {
                history.push('/admin/integration/busy');
              }}
              enabled={user?.tenant_info?.integration_config?.sub_modules?.busy?.is_active}
              connected={!!(Number(integrations?.result?.integration_busy) > 0)}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/zoho');
              }}
              type="zoho"
              enabled={user?.tenant_info?.integration_config?.sub_modules?.zoho_books?.is_active}
              connected={!!(Number(integrations?.result?.integration_zoho) > 0)}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/unicommerce');
              }}
              type="unicommerce"
              enabled={user?.tenant_info?.integration_config?.sub_modules?.unicommerce?.is_active}
              connected={!!(Number(integrations?.result?.integration_unicommerce) > 0)}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/shopify');
              }}
              type="shopify"
              enabled={user?.tenant_info?.integration_config?.sub_modules?.shopify?.is_active}
              connected={!!(Number(integrations?.result?.integration_shopify) > 0)}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/whatsapp');
              }}
              type="whatsapp"
              enabled={user?.tenant_info?.integration_config?.sub_modules?.whatsapp?.is_active}
              connected={!!(Number(integrations?.result?.integration_whatsapp) > 0)}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/quickbooks');
              }}
              type="quickbooks"
              enabled={false}
              connected={false}
            />
            <IntegrationCard
              onClick={() => {
                history.push('/admin/integration/xero');
              }}
              type="xero"
              enabled={false}
              connected={false}
            />
          </div>
        )
        : (
          <div
            className="loading-card__wrapper"
          >
            {
              [1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="loading-card  loadingBlock" />
              ))
            }
          </div>

        )}
    </div>
  );
};

const mapStateToProps = ({ IntegrationReducers, UserReducers }) => ({
  getIntegrationsLoading: IntegrationReducers.getIntegrationsLoading,
  integrations: IntegrationReducers.integrations,
  user: UserReducers.user,

});
const mapDispatchToProps = (dispatch) => ({
  getIntegrations: (orgId, callback) => dispatch(IntegrationActions.getIntegrations(orgId, callback)),
});
Integration.propTypes = {
  getIntegrationsLoading: PropTypes.bool,
  user: PropTypes.any,
  history: PropTypes.func,
  getIntegrations: PropTypes.func,
  integrations: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Integration));
